import React from "react";
import { ColumnsType } from "antd/es/table";
import { Form, Input, Select, Typography } from "antd";
import {
  handleCaculatorForAxis,
  handleCaculatorForCyl,
  handleCaculatorForSph,
} from "pages/Refractive/Caculator copy/CaculatorForOther";

export const selectedData = [
  {
    value: "select",
    label: "Chọn",
  },
  {
    value: "gp",
    label: "Kính kê đơn",
  },
  {
    value: "Pgp",
    label: "Dùng lại kính cũ",
  },
  {
    value: "contactLens",
    label: "Kính tiếp xúc",
  },
  {
    value: "consultDoctor",
    label: "Tham khảo ý kiến bác sĩ",
  },
];

const width = "15%";
const dryRefractionTb1 = (side?, form?) => {
  const dryRefractionTb1: ColumnsType = [
    {
      title: "-",
      dataIndex: "none",
      width: "10%",
    },
    {
      title: "Thị lực không kính",
      dataIndex: "ucva",
      render: (
        text: string | number,
        record: { key: string | number },
        index
      ) => (
        <Form.Item name={["dryRefraction", side, "tb1", "ucva", index]}>
          <Input />
        </Form.Item>
      ),

      width: width,
    },
    {
      title: "Cầu",
      dataIndex: "sph",
      render: (
        text: string | number,
        record: { key: string | number },
        index: number
      ) => (
        <Form.Item name={["dryRefraction", side, "tb1", "sph", index]}>
          <Input
            onChange={(e) =>
              handleCaculatorForSph(
                index,
                form,
                side,
                e.target.value,
                "dryRefraction"
              )
            }
          />
        </Form.Item>
      ),
      width: width,
    },
    {
      title: "Trụ",
      dataIndex: "cyl",
      render: (
        text: string | number,
        record: { key: string | number },
        index: number
      ) => (
        <Form.Item name={["dryRefraction", side, "tb1", "cyl", index]}>
          <Input
            disabled={index === 1 ? true : false}
            onChange={(e) =>
              handleCaculatorForCyl(
                index,
                form,
                side,
                e.target.value,
                "dryRefraction"
              )
            }
          />
        </Form.Item>
      ),
      width: width,
    },
    {
      title: "Trục",
      dataIndex: "axis",
      render: (
        text: string | number,
        record: { key: string | number },
        index: number
      ) => (
        <Form.Item name={["dryRefraction", side, "tb1", "axis", index]}>
          <Input
            disabled={index === 1 ? true : false}
            onChange={(e) =>
              handleCaculatorForAxis(
                index,
                form,
                side,
                e.target.value,
                "dryRefraction"
              )
            }
          />
        </Form.Item>
      ),
      width: width,
    },
    {
      title: "Thị lực với kính",
      dataIndex: "vision",
      render: (
        text: string | number,
        record: { key: string | number },
        index: number
      ) => (
        <Form.Item name={["dryRefraction", side, "tb1", "vision", index]}>
          <Input />
        </Form.Item>
      ),
      width: width,
    },
    {
      title: "Thị lực (kính lỗ)",
      dataIndex: "va",
      render: (
        text: string | number,
        record: { key: string | number },
        index: number
      ) => (
        <Form.Item name={["dryRefraction", side, "tb1", "va", index]}>
          <Input />
        </Form.Item>
      ),
      width: width,
    },
  ];
  return dryRefractionTb1;
};

const dryRefractionTb2 = (side) => {
  const dryRefractionTb2: ColumnsType = [
    {
      title: "name",
      dataIndex: "name",
      render: (text: string | number, record: { key: string | number }) => (
        <Typography>{text}</Typography>
      ),
      width: "25%",
    },
    {
      title: "",
      dataIndex: "",
      render: (text: string | number, record: { key: string | number }) => {
        return (
          <Form.Item name={["dryRefraction", side, "tb2", "comments"]}>
            <Input.TextArea
              style={{
                minHeight: "fit-content",
                boxShadow: "none",
                border: "none",
              }}
              autoSize
              rows={2}
            />
          </Form.Item>
        );
      },
      width: "75%",
      align: "left",
    },
  ];
  return dryRefractionTb2;
};

const adviceDruRefraction = () => {
  const pmtRefractionTb2: ColumnsType = [
    {
      title: "name",
      dataIndex: "name",
      render: (text: string | number, record: { key: string | number }) => (
        <Typography>{text}</Typography>
      ),
      width: "13%",
    },
    {
      title: "",
      dataIndex: "",
      render: (text: string | number, record: { key: string | number }) => {
        return (
          <Form.Item name={["dryRefraction", "left", "tb2", "advice"]}>
            <Select options={selectedData} allowClear />
          </Form.Item>
        );
      },
      width: "87%",
      align: "left",
    },
  ];

  return pmtRefractionTb2;
};

export { dryRefractionTb1, dryRefractionTb2, adviceDruRefraction };
